import './TopContributorCard.scss';

import React, { memo } from 'react';

import bronzeMedal from '../../../../../assets/img/bronze.png';
import goldMedal from '../../../../../assets/img/gold.png';
import silverMedal from '../../../../../assets/img/silver.png';
import CustomAvatar from '../../../../../components/CustomAvatar/CustomAvatar';
import {
  useTQConnectConfig,
} from '../../../../../hooks/queries/tqConnectQueries';
import { numFormatterInUnit } from '../../../../../shared/formatter';
import { useAppNavigate } from '../../../../../shared/hooks';
import { ROUTES } from '../../../../../types/routes';
import TQConnectIcon from '../../TQConnectIcon';

const MEDAL_IMAGES: Record<1 | 2 | 3, string> = {
  1: goldMedal,
  2: silverMedal,
  3: bronzeMedal,
};

export interface TopContributorCardProps {
  userId: string;
  rank: number;
  name: string;
  avatarUrl?: string | null;
  score: number;
  isCurrentUser?: boolean;
  performanceMessage?: number;
}

const TopContributorCard: React.FC<TopContributorCardProps> = ({
  userId,
  rank,
  name,
  avatarUrl,
  score,
  isCurrentUser = false,
  performanceMessage,
}) => {
  const navigate = useAppNavigate();
  const { data: tqConnectConfigResult } = useTQConnectConfig();
  const scoreName =
    tqConnectConfigResult?.tqConnectConfig?.scoreConfig?.name ?? 'TQ';
  const medalSrc =
    rank >= 1 && rank <= 3 ? MEDAL_IMAGES[rank as 1 | 2 | 3] : null;

  const formattedScore = numFormatterInUnit(score, 999);

  return (
    <div
      className={`top-contributor-card ${isCurrentUser ? 'top-contributor-card--current-user' : ''} ${medalSrc ? `top-contributor-card--rank-${rank}` : ''}`}>
      <div
        className="top-contributor-card__main"
        onClick={() => {
          navigate(ROUTES.USER_PROFILE, {
            userId: userId,
          });
        }}>
        <span className="top-contributor-card__rank">#{rank}</span>
        <CustomAvatar
          src={avatarUrl ?? undefined}
          name={!avatarUrl ? name : undefined}
          size={44}
          border={0}
          className="top-contributor-card__avatar"
        />
        <div className="top-contributor-card__info">
          <span className="top-contributor-card__name">{name}</span>
          <div className="top-contributor-card__score">
            <TQConnectIcon
              size={16}
              className="top-contributor-card__score-icon"
            />
            <span>
              {formattedScore} {scoreName}
            </span>
          </div>
        </div>
        {medalSrc && (
          <img
            src={medalSrc}
            alt={`Rank ${rank}`}
            className="top-contributor-card__medal"
          />
        )}
      </div>
      {isCurrentUser && performanceMessage && (
        <div className="top-contributor-card__performance">
          You are doing better than {performanceMessage} % of members
        </div>
      )}
    </div>
  );
};

export default memo(TopContributorCard);
